import * as api from '../api';
import { Model } from '../common';
import { MembershipProduct } from './MembershipProduct';

@Model('Membership')
export class Membership extends api.ApiMembership {
    level : MembershipProduct;
    product : MembershipProduct;

    private numberAsMoney(cents) {
        return `$${(cents / 100).toFixed(2)}`;
    }

    get pricePerPeriod() : string {
        return `${this.numberAsMoney(this.price)} / ${this.period}`;
    }

    /**
     * Modify the user's membership to a new memberhsip level
     */
    modify(level : any, annual : boolean): Promise<Membership> {
        return <any>Membership
            .inject(api.UsersApi)
            .modifyMembership({
                annual,
                level_id: level.id
            })
            .toPromise()
            .catch(response => {
                throw response.json();
            })
        ;
    }

    /**
     * Modify the user's membership to a new memberhsip level
     */
    modifyPreview(level : any, annual : boolean): Promise<api.ApiMembershipChangePreview> {
        return Membership
            .inject(api.UsersApi)
            .previewMembershipChange({
                annual,
                level_id: level.id
            })
            .toPromise()
            .catch(response => {
                throw response.json();
            })
        ;
    }

    changePaymentSource(gatewayName : string, gatewayData : any) : Promise<void> {
        return Membership
            .inject(api.UsersApi)
            .changePaymentSource({
                gateway_name: gatewayName,
                gateway_data: gatewayData
            })
            .toPromise()
            .then(response => {
                this.adapt(response.getData());
            })
            .catch(response => {
                throw response.json();
            })
        ;
    }

    // TypeError: Cannot read property 'getData' of null
    // at Membership.ts:84
    // at ZoneDelegate.webpackJsonp.1019.ZoneDelegate.invoke (zone.js:391)
    // at Object.onInvoke (core.es5.js:3933)
    // at ZoneDelegate.webpackJsonp.1019.ZoneDelegate.invoke (zone.js:390)
    // at Zone.webpackJsonp.1019.Zone.run (zone.js:141)
    // at zone.js:818
    // at ZoneDelegate.webpackJsonp.1019.ZoneDelegate.invokeTask (zone.js:424)
    // at Object.onInvokeTask (core.es5.js:3924)
    // at ZoneDelegate.webpackJsonp.1019.ZoneDelegate.invokeTask (zone.js:423)
    // at Zone.webpackJsonp.1019.Zone.runTask (zone.js:191)

    async cancel(cancelReason : string, atPeriodEnd : boolean): Promise<Membership> {

        let response;
        
        try {
            response = await Membership
                .inject(api.UsersApi)
                .cancelMembership({
                    reason: cancelReason,
                    at_period_end: atPeriodEnd
                })
                .toPromise()
            ;
        } catch (e) {
            if (e.json) {
                throw e.json();
            } else {
                console.error("Caught JS error while cancelling membership:");
                console.error(e);
                throw e;
            }
        }

        if (response) {
            this.adapt(response.getData());
            return this;
        } else {
            return null;
        }
    }

    reactivate() : Promise<void> {
        return Membership
            .inject(api.UsersApi)
            .reactivateMembership()
            .toPromise()
            .then(membership => {
                this.adapt(membership.getData())
            })
            .catch(response => {
                throw response.json();
            })
        ;
    }
}